import { faBell } from "@awesome.me/kit-44b29310a6/icons/classic/regular"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "core/components/Button"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTrigger,
} from "@/core/components/dialogs/Sheet"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "core/components/Tabs"
import { useTranslation } from "next-i18next"
import { useState } from "react"
import { useUnreadNotificationsCount } from "../hooks/useUnreadNotificationsCount"
import { NotificationCategory } from "../types/notificationCategory"
import { NotificationScope } from "../types/notificationScope"
import { NotificationListContainer } from "./NotificationListContainer"

export const NotificationSheet = () => {
  const { t } = useTranslation("notifications")
  const [scope, setScope] = useState(NotificationScope.PERSONAL)
  const {
    total: allCount,
    candidates: candidatesCount,
    tasks: tasksCount,
  } = useUnreadNotificationsCount(scope)

  const tabs = [
    { key: NotificationCategory.ALL, label: t("tabs.all"), unread: allCount },
    {
      key: NotificationCategory.CANDIDATES,
      label: t("tabs.candidates"),
      unread: candidatesCount,
    },
    {
      key: NotificationCategory.TASKS,
      label: t("tabs.tasks"),
      unread: tasksCount,
    },
  ]

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          size="icon"
          text={t("title")}
          variant="text"
          className="relative"
        >
          <div className="relative flex h-5 w-5 items-center justify-center">
            <FontAwesomeIcon
              className={`text-on-surface-variant h-full w-full cursor-pointer ${allCount > 0 ? "animate-pulse" : ""}`}
              icon={faBell}
              size="lg"
            />
            {allCount > 0 && (
              <div className="absolute -top-0.5 right-0.5 h-2 w-2 rounded-full bg-red-400" />
            )}
          </div>
        </Button>
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>{t("title")}</SheetHeader>
        <Tabs
          defaultValue={tabs[0].key}
          className="flex flex-1 flex-col overflow-hidden"
        >
          <TabsList className="w-full overflow-x-auto">
            {tabs.map((tab) => (
              <TabsTrigger key={tab.key} className="group" value={tab.key}>
                {tab.label}
                {tab.unread > 0 && (
                  <div className="group-data-[state=active]:bg-primary/10 text-md rounded-full bg-gray-200 px-1.5">
                    {tab.unread}
                  </div>
                )}
              </TabsTrigger>
            ))}
          </TabsList>
          <div className="bg-container-highest h-px w-full" />
          {tabs.map((tab) => (
            <TabsContent
              className="flex-1 overflow-y-auto pb-[52px]"
              key={tab.key}
              value={tab.key}
              forceMount
            >
              <NotificationListContainer scope={scope} category={tab.key} />
            </TabsContent>
          ))}
        </Tabs>
      </SheetContent>
    </Sheet>
  )
}
